// -------------------------------------------------------------------------------------------------
// Import
// -------------------------------------------------------------------------------------------------

import {
  intersection as _intersection,
  debounce as _debounce,
  merge as _merge,
} from 'lodash-es';
import $ from 'jquery';
import { FilterableMap } from './_filterableMap';
import { pushTrackerEvent } from '../_googleTagManager';
import { getTextSwitchByElement } from './_textSwitch';
import { runOnPageload } from '../runner-pageload';
import {convertCssDurationToMilliseconds, getQueryVar} from '../_util';
import runOnVisible from '../runner-visible';
import {
  hasVendorConsent,
  watchVendorConsentUpdate,
} from '../plugins/cmp-helpers';
import {CONSENT_GOOGLE_MAPS} from '../consentVendors';
import {
  addConsentPlaceholder,
  removeConsentPlaceholder,
} from '../plugins/cmp-placeholder';
import MarkerClusterer from '@googlemaps/markerclustererplus';

// -------------------------------------------------------------------------------------------------
// Variables
// -------------------------------------------------------------------------------------------------

const baseClass = 'locations-catalog';
let catalogs = [];
let globalFilter = {};
let clusterMap = null;
let isQueryFilterApplied = false;
// -------------------------------------------------------------------------------------------------
// Classes
// -------------------------------------------------------------------------------------------------

export class LocationsCatalog {
  constructor(el, useFadeOutAnimation) {
    this._filter = {};
    this._useFadeOutAnimation = useFadeOutAnimation;
    this._buttonsEnabled = true;
    this._filtersVisible = true;
    this._mapVisible = false;

    this.el = el;
    this.$sectorBtns = $(el).find(`.${baseClass}__sector-btn`);
    this.$sectorReset = $(el).find(`.${baseClass}__sector-reset`);
    this.$displayCountComplete = $(el).find(`.${baseClass}__display-count__complete`);
    this.$displayCountN = $(el).find(`.${baseClass}__display-count__n`);
    this.$items = $(el).find(`.${baseClass}__item`);
    this.$mapWrapper = $(el).find(`.${baseClass}__map-wrapper`);
    this.$mapSearch = $(el).find(`.${baseClass}__map-search`);
    this.$map = this.$mapWrapper.find(`.${baseClass}__map`);
    this.$headline = $(el).find(`.${baseClass}__boxes-header`);
    this.switcher = $(el).find(`.text-switch__button`);
    this.leaf = $(el).find(`.leaf__info`);

    this.vendorConsentSubscription = null;

    this.filter = $(el).find(`.${baseClass}__filter`);
    this.filterToggle = $(el).find(`.${baseClass}__filter-button`);
    this.search = $(el).find(`.${baseClass}__search`);
    this._debouncedAnimationFinish = this.onAnimationFinished;
    this._markerCluster = null;

    runOnVisible(this.el, async () => {
      await this.start();
    });
  }

  async start() {
    if (this._filterableMap != null) {
      return;
    }

    this._filterableMap = new FilterableMap(this.$map, this.el.dataset.marker, this.el.dataset.markerLocation);
    this._filterableMap.addSuggestionVisibleListener(this.onSuggestionsVisible.bind(this));

    this.$displayCountComplete.text(this.$items.length);

    if (this._useFadeOutAnimation) {
      const fadeOutDuration = window.getComputedStyle(this.$items.parent()[0]).transitionDuration;
      this._debouncedAnimationFinish = _debounce(this.onAnimationFinished.bind(this), convertCssDurationToMilliseconds(fadeOutDuration) * 1.25);
    }

    let mapIsShow = false;
    $(this.el).find('[name=map-toggle]').change((e) => {
      if (e.currentTarget.checked) {
        this.showMapTab();
        mapIsShow = true;

        $(`.${baseClass} .leaf__overlay`).css('display', 'none');
        $(`.${baseClass} .leaf__info`).removeClass('open');

      } else {
        this.hideMapTab();
        $(`.${baseClass} .leaf__overlay`).css('display', '');
      }
    });

    this.switcher.on('click', (e) => {
      $(`.${baseClass}__item.is-active`).removeClass('is-active');
      $(`.${baseClass}__items`).scrollTop(0);
    });

    this.search.find('input').on('keyup', (e) => {
      if (e.currentTarget.value.length >= 1) {
        if (mapIsShow === false) {
          $('.text-switch__button').trigger('click');
          mapIsShow = true;
        }
      }
    });

    this.$sectorBtns.on('click', (e) => {
      if (this.buttonsEnabled === false) {
        return;
      }

      const btnEl = e.currentTarget;

      if (btnEl.classList.contains('active')) {
        this.removeFilter(btnEl.dataset.type, btnEl.dataset.id);
        return;
      }

      this.addFilter(btnEl.dataset.type, btnEl.dataset.id);
    }).prop('disabled', false);

    this.$sectorReset.on('click', 'button', () => {
      this.clearFilters();
      this.$sectorReset.find('.btn').text('Alle Standorte');
    });

    this.filter.on('click', (e) => {
      if (e.target.classList.contains('btn') && !e.target.parentNode.classList.contains(`${baseClass}__sector-reset`)) {
        if (e.target.classList.contains('is-active')) {
          Array.from(document.querySelectorAll(`.${baseClass}__filter button`)).map(item => {
            item.classList.remove('is-active');
          });
        } else {
          Array.from(document.querySelectorAll(`.${baseClass}__filter button`)).map(item => {
            item.classList.remove('is-active');
          });

          e.target.classList.add('is-active');
        }
      }
    });

    this.filterToggle.on('click', (e) => {
      let txt = e.target.querySelector('span').innerText;
      e.target.querySelector('span').innerText = txt == '-' ? '+' : '-';
      document.querySelector(`.${baseClass}__filter-container`).classList.toggle('is-show');

      document.querySelector(`.${baseClass}__map-wrapper`).classList.toggle('space-top');
      document.querySelector(`.${baseClass}__items`).classList.toggle('space-top');
      document.querySelector(`.${baseClass}__filter`).classList.toggle('space-top');

    });

    const mq = window.matchMedia("(max-width: 767px)");

    if (mq.matches && this.filterToggle) {
      // this.filterToggle.trigger("click");
    }

    this.updateItems(false);
    this.updateSectorButtons();

    const sector = getQueryVar('sector');
    if (sector != null) {
      this.addFilter(1, sector);
    }

    const type = getQueryVar('type');
    if (type != null) {
      this.addFilter(2, type);
    }

    runOnPageload(() => {
      const mapVisible = this.el.classList.contains(`${baseClass}--map-visible`);
      this.mapSwitch = getTextSwitchByElement(this.el.querySelector(`.${baseClass}__boxes-header-switch .text-switch`));

      if (mapVisible) {
        if (this.mapSwitch != null) {
          this.mapSwitch.isOn = true;
        } else {
          this.showMapTab();
        }
      }
    });

    this.setOrder();

    if (this.$headline.length >= 1) {
      document.querySelector(`.${baseClass}`).classList.add(`${baseClass}--has-headline`);
    }
  }

  setOrder(hideDiv) {
    let count = 1;
    Array.from(document.querySelectorAll(`.${baseClass}__item`)).map(item => {
      item.style.removeProperty('order');
    });

    Array.from(document.querySelectorAll(`.${baseClass}__item`)).map(item => {
      if (hideDiv === true) {
        if (!item.classList.contains('d-none')) {
          item.style.order = count;
          ++count;
        }
      } else {
        item.style.order = count;
        ++count;
      }
    });
  }

  hasFilterSector() {
    return Object.keys(this._filter).length >= 1;
  }

  updateSectorButtons() {
    this.$sectorBtns.removeClass('active');

    for (const [type, ids] of Object.entries(this._filter)) {
      for (const id of ids) {
        $(this.el).find(`[data-type="${type}"][data-id=${id}]`).addClass('active');
      }
    }

    // this.$sectorReset.toggleClass('d-none', !this.hasFilterSector());
  }

  onAnimationFinished() {
    const visibleItems = this.$items
      .addClass('d-none')
      .filter(((i, el) => {
        let matchSector = true;
        const itemFilters = JSON.parse(el.dataset.filter);

        for (const [ type, values ] of Object.entries(_merge(this._filter, globalFilter))) {
          matchSector = matchSector
            && itemFilters[type] != null
            && _intersection(itemFilters[type], values).length > 0;

          if (matchSector === false) {
            break;
          }
        }

        return matchSector;
      }));

    visibleItems.removeClass('d-none');

    this.$items.parent().add(this.$mapWrapper).removeClass('locations-catalog__fade-out');

    let count = visibleItems.length;
    if (Number.isNaN(count)) count = 0;

    this.$displayCountN.text(new Intl.NumberFormat('de-DE').format(count));

    this.showMarkers(this.convertItemsToMarkerData(visibleItems));

    if (this.$items.length === count) {
      this.$sectorReset.removeClass('btn-normal');
      Array.from(document.querySelectorAll(`.${baseClass}__filter button`)).map(item => {
        item.classList.remove('is-selected');
      });
    } else {
      this.$sectorReset.addClass('btn-normal');
    }

    this.setOrder(true);

    function activeLeafs(type, id) {
      let count = 0;
      for (let c of visibleItems) {
        let itemFilters = JSON.parse(c.dataset.filter);

        if (itemFilters[type] !== undefined) {
          if (itemFilters[type].includes(parseInt(id))) {
            ++count;
          }
        }
      }

      return count;
    }

    for (let x of document.querySelectorAll('.locations-catalog__filter-container ul')) {
      let countActiveInput = x.querySelectorAll('input:checked').length;

      if (countActiveInput === 0) {
        x.previousElementSibling.classList.remove('is-selected');
      } else {
        x.previousElementSibling.classList.add('is-selected');
        document.querySelector('body').classList.remove('location-query');
      }

      for (let item of x.querySelectorAll('.locations-catalog__sector-btn')) {
        let getType = item.getAttribute('data-type');
        let getId = item.getAttribute('data-id');
        let countActives = activeLeafs(getType, getId)

        if (countActives === 0) {
          item.closest('.form-check').classList.add('disable');
        } else {
          item.closest('.form-check').classList.remove('disable');
        }
      }

      if (x.previousElementSibling.innerText === 'Fachgebiete') {
        let checkedItems = x.querySelectorAll('input:checked').length;

        if (checkedItems >= 1) {
          for (let item of x.querySelectorAll('.form-check')) {
            if (!item.querySelector('input:checked')) {
              item.closest('.form-check').classList.add('disable');
            }
          }
        } else {
          for (let item of x.querySelectorAll('.locations-catalog__sector-btn')) {
            if (x.closest('.position-relative').querySelector('button').innerText === 'Fachgebiete') {
              let getType = item.getAttribute('data-type');
              let getId = item.getAttribute('data-id');
              let countActives = activeLeafs(getType, getId)

              if (countActives === 0) {
                item.closest('.form-check').classList.add('disable');
              } else {
                item.closest('.form-check').classList.remove('disable');
              }
            }
          }
        }
      }

      if (x.previousElementSibling.innerText === 'Zielgruppe') {
        let checkedItems = x.querySelectorAll('input:checked').length;

        if (checkedItems >= 1) {
          for (let item of x.querySelectorAll('.form-check')) {
            if (!item.querySelector('input:checked')) {
              item.closest('.form-check').classList.add('disable');
            }
          }
        }
      }
    }

    const targetButtons = document.querySelectorAll('.locations-catalog__filter-container button');
    const config = { attributes: true, attributeFilter: ['class'] };

    const callback = function(mutationsList, observer) {
      for (let mutation of mutationsList) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          const targetButton = mutation.target;
          if (targetButton.classList.contains('is-selected')) {
            setTimeout(function (){
              document.querySelector('.locations-catalog').classList.remove('locations-catalog--loading');
              document.querySelector('.locations-catalog__filter').classList.remove('space-top');
              document.querySelector('.locations-catalog__filter-container').classList.remove('is-.show');
            }, 300)
          }
        }
      }
    };

    targetButtons.forEach(button => {
      const observer = new MutationObserver(callback);
      observer.observe(button, config);
    });


    if (this.hasFilterSector() === false) {
      this.$sectorReset.find('.btn').text('Alle Standorte');
    } else {
      this.$sectorReset.find('.btn').text('Filter entfernen');
    }
  }

  updateItems(overwriteAnimation = null) {
    this.$items.parent().add(this.$mapWrapper).addClass('locations-catalog__fade-out');

    if (overwriteAnimation == null) {
      this._debouncedAnimationFinish();
    } else {
      this.onAnimationFinished();
    }
  }

  addFilter(type, value) {
    if (this._filter[type] == null) {
      this._filter[type] = [];
    }

    this._filter[type].push(parseInt(value));
    this._filter[type] = [ ...new Set(this._filter[type]) ];

    this.updateDisplay();
  }

  removeFilter(type, value) {
    if (this._filter[type] == null) {
      return;
    }

    const foundIndex = this._filter[type].indexOf(parseInt(value));
    if (foundIndex === -1) {
      return;
    }

    this._filter[type].splice(foundIndex, 1);

    if (this._filter[type].length === 0) {
      delete this._filter[type];
    }

    this.updateDisplay();
  }

  clearFilters() {
    this._filter = {};
    this.$sectorBtns.prop('checked', false);

    this.updateDisplay();
  }

  updateDisplay() {
    this.updateSectorButtons();
    this.updateItems();
  }

  showMapTab() {
    $(this.el).addClass(`${baseClass}--map-visible`);

    this.showMap();
  }

  hideMapTab() {
    $(this.el).removeClass(`${baseClass}--map-visible`);
    removeConsentPlaceholder(this.el.getElementsByClassName(`${baseClass}__map`)[0]);

    this.hideMap();
  }

  showMap() {
    this.vendorConsentSubscription = watchVendorConsentUpdate(CONSENT_GOOGLE_MAPS, async (hasConsent) => {
      const map = this.el.getElementsByClassName(`${baseClass}__map`)[0];

      if (hasConsent) {
        removeConsentPlaceholder(map);

        await this._filterableMap.showMap();

        if ($(this.el).find('[name=filter-places-search]').length >= 1) {
          this._filterableMap.enableAutocomplete($(this.el).find('[name=filter-places-search]')[0]);
        }

        if ($(this.el).find('[name=places-search]').length >= 1) {
          this._filterableMap.enableAutocomplete($(this.el).find('[name=places-search]')[0]);
        }

        this._mapVisible = true;

        this.updateItems(true);

        pushTrackerEvent('showLocationsMap');
      } else {
        console.log('no consent!', hasConsent);
        this.hideMap();

        await addConsentPlaceholder(map, CONSENT_GOOGLE_MAPS);
      }
    });
  }

  hideMap() {
    $(this.el).removeClass(`${baseClass}--no-consent`);

    this.vendorConsentSubscription?.disconnect();

    if (this._mapVisible) {
      this._filterableMap.hideMap();
      this._mapVisible = false;

      pushTrackerEvent('hideLocationsMap');
    }
  }

  convertItemsToMarkerData(items) {
    return Array.from(items).map(item => {
      const lat = parseFloat(item.dataset.lat);
      const lng = parseFloat(item.dataset.lng);
      const title = item.querySelector('.leaf__body h3').textContent.trim();

      return {
        lat,
        lng,
        title,
      };
    });
  }

  onSuggestionsVisible(visible) {
    if (visible) {
      this.$mapSearch.addClass(`${baseClass}__map-search--places-visible`);
    } else {
      this.$mapSearch.removeClass(`${baseClass}__map-search--places-visible`);
    }
  }

  showMarkers(markers) {
    if (this._mapVisible === false) {
      return;
    }

    if (clusterMap) {
      clusterMap.clearMarkers();
    }

    this._filterableMap.clearMarkers();

    for (let { lat, lng, title } of markers) {
      this._filterableMap.addMarker(lat, lng, title);
    }

    let map = this._filterableMap.getOnlyMap();
    let clustermarkers = this._filterableMap.getMarkers();

    this._filterableMap.focusOnMarkers();

    let clusteringMarkerPath = document.querySelector('[data-clustering-path]').getAttribute('data-clustering-path');
    const urlStart = window.location.origin

    clusterMap = new MarkerClusterer(
      map,
      clustermarkers,
      {imagePath: `${urlStart}${clusteringMarkerPath}`}
    )
  }

  set buttonsEnabled(value) {
    this._buttonsEnabled = value;
  }

  get buttonsEnabled() {
    return this._buttonsEnabled;
  }

  set filtersVisible(value) {
    if (this._filtersVisible === value) {
      return;
    }

    this._filtersVisible = value;

    if (value) {
      $(this.el).find(`.${baseClass}__sector`).show();
    } else {
      $(this.el).find(`.${baseClass}__sector`).hide();
    }
  }

  get filtersVisible() {
    return this._filtersVisible;
  }

  queryVarFilter() {
    const specialties = getQueryVar('fachgebiet');
    const treatment = getQueryVar('behandlungsform');
    const targetgroup = getQueryVar('zielgruppe');
    const depiction = getQueryVar('darstellung');

    if (this.$sectorBtns && (specialties || treatment || targetgroup)) {
      document.querySelector('body').classList.add('location-query');
      const setId = (type, queryVar) => {
        if (!queryVar) {
          console.error("queryVar is null or undefined");
          return null;
        }

        let id = null;
        document.querySelectorAll(`.locations-catalog__filter .locations-catalog__sector-btn[data-type="${type}"]`).forEach(item => {
          if (item.closest('.form-check').querySelector('.form-check-label').innerText.toLowerCase() === queryVar.toLowerCase()) {
            id = parseInt(item.getAttribute('data-id'));
          }
        });
        return id;
      };

      let fachgebietId = setId(1, specialties);
      let behandlungsformId = setId(2, treatment);
      let zielgruppeId = setId(3, targetgroup);

      let foundFachgebietId = false;
      let foundBehandlungsformId = false;
      let foundZielgruppeId = false;

      setTimeout(() => {
        if (fachgebietId !== null) {
          document.querySelectorAll('.locations-catalog__filter .locations-catalog__sector-btn[data-type="1"]').forEach(item => {
            if (item.closest('.form-check').querySelector('label').innerText.toLocaleLowerCase() === specialties.toLocaleLowerCase()) {
              if (!item.closest('.form-check').classList.contains('disable')) {
                item.click();
                foundFachgebietId = true;
              }
            }
          });
        }

        if (behandlungsformId !== null) {
          document.querySelectorAll('.locations-catalog__filter .locations-catalog__sector-btn[data-type="2"]').forEach(item => {
            if (item.closest('.form-check').querySelector('label').innerText.toLocaleLowerCase() === treatment.toLocaleLowerCase()) {
              if (!item.closest('.form-check').classList.contains('disable')) {
                item.click();
                foundBehandlungsformId = true;
              }
            }
        });
        }

        if (zielgruppeId !== null) {
          document.querySelectorAll('.locations-catalog__filter .locations-catalog__sector-btn[data-type="3"]').forEach(item => {
            if (item.closest('.form-check').querySelector('label').innerText.toLocaleLowerCase() === targetgroup.toLocaleLowerCase()) {
              if (!item.closest('.form-check').classList.contains('disable')) {
                item.click();
                foundZielgruppeId = true;
              }
            }
          });
        }

        if (foundBehandlungsformId == false && foundBehandlungsformId == false && foundZielgruppeId == false) {
          setTimeout(function () {
            document.querySelector('body').classList.remove('location-query');
            document.querySelector('.locations-catalog').classList.remove('locations-catalog--loading')
            isQueryFilterApplied = true;
          },1000)
        }

        this.mapSwitch.isOff = true;

        if (depiction) {
          if (depiction === 'karte') {
            this.mapSwitch = getTextSwitchByElement(this.el.querySelector(`.${baseClass}__boxes-header-switch .text-switch`));
            this.mapSwitch.isOn = true;
            this.showMapTab();

            $(`.${baseClass} .leaf__overlay`).css('display', 'none');
            $(`.${baseClass} .leaf__info`).removeClass('open');
          }
        }
      }, 1000);
    } else {
      if (this.$sectorBtns && depiction) {
        if (depiction === 'karte') {
          setTimeout(() => {
            this.mapSwitch = getTextSwitchByElement(this.el.querySelector(`.${baseClass}__boxes-header-switch .text-switch`));
            this.mapSwitch.isOn = true;
            this.showMapTab();

            $(`.${baseClass} .leaf__overlay`).css('display', 'none');
            $(`.${baseClass} .leaf__info`).removeClass('open');
          },1000);

          setTimeout(() => {
            $(`.${baseClass}`).removeClass('locations-catalog--loading');
          },1150);
        }
      }
    }
  }




}

// -------------------------------------------------------------------------------------------------
// Methods
// -------------------------------------------------------------------------------------------------

export function init() {
  $(`.${baseClass}`).not(`.${baseClass}--with-slider`).each((i, el) => {
    registerCatalog(new LocationsCatalog(el, $(el).hasClass(`${baseClass}--no-animations`) === false));
  });


  $(window).on('resize', function() {
    if ($(window).width() >= 992) {
      if ($('.locations-catalog--map-visible').length >= 1) {
        $('.locations-catalog--map-visible .leaf__info').each(function () {
          if ($(this).hasClass('open')) {
            $(`.${baseClass} .leaf__overlay`).css('display', '');
          }
        });
      }
    }
  });

  document.addEventListener("click", function(e) {
    if (e.target.closest(`.${baseClass}__filter-container`) !== null) {
      if (e.target.classList.contains('btn') ||
        e.target.classList.contains('form-check') ||
        e.target.classList.contains('form-check-input') ||
        e.target.classList.contains('form-check-label') ||
        e.target.tagName === 'UL' ||
        e.target.tagName === 'LI') {
        return;
      }

      Array.from(document.querySelectorAll(`.${baseClass}__filter .btn`)).map(item => {
        item.classList.remove('is-active');
      });
    } else {
      Array.from(document.querySelectorAll(`.${baseClass}__filter .btn`)).map(item => {
        item.classList.remove('is-active');
      });
    }
  });

  window.addEventListener('pageshow', () => {
    const specialties = getQueryVar('fachgebiet');
    const treatment = getQueryVar('behandlungsform');
    const targetgroup = getQueryVar('zielgruppe');

    if (!specialties && !treatment && !targetgroup) {
      let resetButton = document.querySelector('.locations-catalog__sector-reset button');
      if (resetButton != null) {
        resetButton.click();
      }
    }
  });
}

export function registerCatalog(catalog) {
  catalogs.push(catalog);
  catalog.queryVarFilter();
}

export function addGlobalFilter(type, value) {
  if (globalFilter[type] == null) {
    globalFilter[type] = [];
  }

  globalFilter[type].push(parseInt(value));
  globalFilter[type] = [ ...new Set(globalFilter[type]) ];

  updateAllDisplays();
}

export function removeGlobalFilter(type, value) {
  if (globalFilter[type] == null) {
    return;
  }

  const foundIndex = globalFilter[type].indexOf(parseInt(value));
  if (foundIndex === -1) {
    return;
  }

  globalFilter[type].splice(foundIndex, 1);

  if (globalFilter[type].length === 0) {
    delete globalFilter[type];
  }

  updateAllDisplays();
}

export function resetGlobalFilter() {
  globalFilter = {};

  updateAllDisplays();
}

function updateAllDisplays() {
  for (const catalog of catalogs) {
    catalog.updateDisplay();
  }
}

// -------------------------------------------------------------------------------------------------
// Export
// -------------------------------------------------------------------------------------------------

export default {
  init,
  addGlobalFilter,
  removeGlobalFilter,
};
